import { create } from "zustand";

export type DocumentType = "iframe" | "markdown" | "image";

interface DocumentState {
	isOpen: boolean;
	currentDocumentUrl: string | null;
	documentTitle: string | null;
	documentType: DocumentType;
	openDocument: (documentTitle: string, documentUrl: string, documentType?: DocumentType) => Promise<void>;
	closeDocument: () => void;
	error: string | null;
}

export const useDocumentStore = create<DocumentState>((set, get) => ({
	isOpen: false,
	currentDocumentUrl: null,
	currentVersion: null,
	error: null,
	documentTitle: null,
	documentType: "iframe",

	openDocument: async (documentTitle, documentUrl, documentType = "iframe") => {
		try {
			set({
				isOpen: true,
				currentDocumentUrl: documentUrl,
				documentTitle: documentTitle,
				documentType: documentType,
				error: null
			});
		} catch (error) {
			set({
				error: error instanceof Error ? error.message : "Failed to load document"
			});
		}
	},

	closeDocument: () => {
		set({
			isOpen: false,
			currentDocumentUrl: null,
			documentType: "iframe"
		});
	},

}));
